import { apiClient } from '@/shared/lib/axios';
import {
  AdminInsurerAttention,
  AdminInsurerAttentionInitData,
  AdminInsurerAttentionQuery,
} from '@/types/admin-insurer-attention';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

type ApiResponse<T> = { data: T };

type InsurerAttentionListResponse = {
  data: {
    data: AdminInsurerAttention[];
    meta: {
      total: number;
      per_page: number;
      current_page: number;
      last_page: number;
      from: number | null;
      to: number | null;
    };
  };
};

export const getAdminInsurerAttentionInit = async (
  siteType: string
): Promise<ApiResponse<AdminInsurerAttentionInitData>> => {
  const response = await apiClient.get<ApiResponse<AdminInsurerAttentionInitData>>(
    `/admin/${siteType}/insurer-attentions/init`
  );
  return response.data;
};

export const useAdminInsurerAttentionInit = () => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';

  return useQuery({
    queryKey: ['admin-insurer-attention-init', siteType],
    queryFn: () => getAdminInsurerAttentionInit(siteType),
    select: res => res.data,
  });
};


export const getAdminInsurerAttentionList = async (
  siteType: string,
  query?: AdminInsurerAttentionQuery
): Promise<InsurerAttentionListResponse> => {
  const response = await apiClient.get<InsurerAttentionListResponse>(
    `/admin/${siteType}/insurer-attentions`,
    { params: query }
  );
  return response.data;
};

export const useAdminInsurerAttentionList = (query: AdminInsurerAttentionQuery) => {
  const { site } = useParams<{ site: string }>();
  const siteType = site ?? 'medix';

  return useQuery({
    queryKey: ['admin-insurer-attentions', siteType, query],
    queryFn: () => getAdminInsurerAttentionList(siteType, query),
    select: res => res.data,
  });
};
